import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useState, createElement } from 'react';
import { Icon } from '../icon/icon.component.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Text } from '../text/text.component.js';
import { NotificationWrapper, Notification } from './notification.style.js';
import randomKey from '../../node_modules/@arcadiapower/warbler/dist/number/random-key.js';

const Context = createContext({});
const DEFAULT_DISPLAY_TIME = 5000;
const colorMap = {
    error: { color: 'errorBright', backgroundColor: 'error' },
    info: { color: 'primary', backgroundColor: 'primary' },
    success: { color: 'successBright', backgroundColor: 'success' },
    warning: { color: 'warningBright', backgroundColor: 'warning' },
};
const iconMap = {
    error: 'ExclamationCircleInverted',
    info: 'InfoCircleInverted',
    success: 'CheckmarkCircleInverted',
    warning: 'InfoCircleInverted',
};
const Provider = props => {
    var _a;
    const { children, notificationProps = {}, wrapperProps = {} } = props;
    const [notifications, setNotifications] = useState([]);
    const removeNotification = removalId => {
        setNotifications(notifications => notifications.filter(({ id, onRemove }) => {
            const notificationToBeRemoved = id === removalId;
            if (notificationToBeRemoved && onRemove)
                onRemove();
            return !notificationToBeRemoved;
        }));
    };
    const addNotification = params => {
        const id = randomKey();
        const { displayTime = DEFAULT_DISPLAY_TIME, message, onAdd, onRemove, variant, position = 'right', } = params;
        const notification = {
            id,
            message,
            onRemove,
            variant,
            position,
        };
        setNotifications(prevNotifications => [...prevNotifications, notification]);
        setTimeout(() => removeNotification(id), displayTime);
        onAdd === null || onAdd === void 0 ? void 0 : onAdd();
        return id;
    };
    return (jsxs(Context.Provider
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    , Object.assign({ 
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            addNotification,
            removeNotification,
        } }, { children: [children, jsx(NotificationWrapper, Object.assign({}, wrapperProps, { position: ((_a = notifications[0]) === null || _a === void 0 ? void 0 : _a.position) || 'right' }, { children: notifications.map(item => (createElement(Notification, Object.assign({}, notificationProps, { backgroundColor: colorMap[item.variant].backgroundColor, key: item.id, role: "alert" }),
                    jsx(Icon, { icon: iconMap[item.variant], color: colorMap[item.variant].color, margin: { right: '8px' }, opacity: "high" }, void 0),
                    jsx(Text, { children: item.message }, void 0),
                    jsx(IconButton, { onClick: () => removeNotification(item.id), icon: "UIClose", "aria-label": "Close notification", "data-testid": "close-button" }, void 0)))) }), void 0)] }), void 0));
};

export { Context, Provider };
